
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dmarc-inspector",
      function () {
        return require("private-next-pages/dmarc-inspector.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dmarc-inspector"])
      });
    }
  